import { FC } from 'react';
import { cn } from '@/utils/cn';

interface StatusIndicatorProps {
  status: 'healthy' | 'unhealthy' | 'checking';
  className?: string;
  showText?: boolean;
}

export const StatusIndicator: FC<StatusIndicatorProps> = ({ 
  status, 
  className = '', 
  showText = false 
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'healthy':
        return {
          color: 'bg-green-500',
          text: '服务正常',
          pulse: false,
        };
      case 'unhealthy':
        return {
          color: 'bg-red-500',
          text: '服务异常',
          pulse: false,
        };
      case 'checking':
        return {
          color: 'bg-yellow-500',
          text: '检查中...',
          pulse: true,
        };
      default:
        return {
          color: 'bg-gray-500',
          text: '未知状态',
          pulse: false,
        };
    }
  };

  const config = getStatusConfig();

  return (
    <div className={cn('flex items-center space-x-2', className)}>
      <div className="relative">
        <div 
          className={cn(
            'w-2 h-2 rounded-full',
            config.color,
            config.pulse && 'animate-pulse'
          )}
        />
        {config.pulse && (
          <div 
            className={cn(
              'absolute inset-0 w-2 h-2 rounded-full animate-ping',
              config.color,
              'opacity-75'
            )}
          />
        )}
      </div>
      {showText && (
        <span className="text-xs text-gray-600">
          {config.text}
        </span>
      )}
    </div>
  );
};